import relatorioConsumoFinanceiro from '@/repositories/conecta-sus/almoxarifado/relatorioConsumoFinanceiroRepository'
import relatorioEntrada from '@/repositories/conecta-sus/almoxarifado/relatorioEntradaRepository'
import motivoBaixa from '@/repositories/conecta-sus/almoxarifado/motivoBaixaRepository'
import entrada from '@/repositories/conecta-sus/almoxarifado/entradaRepository'
import saida from '@/repositories/conecta-sus/almoxarifado/saidaRepository'
import baixa from '@/repositories/conecta-sus/almoxarifado/baixaRepository'
import inventario from '@/repositories/conecta-sus/almoxarifado/inventarioRepository'
import entradaInicial from '@/repositories/conecta-sus/almoxarifado/entradaInicialRepository'
import parametrizacao from '@/repositories/conecta-sus/almoxarifado/parametrizacaoRepository'
import requisicaoPendentePermissao from '@/repositories/conecta-sus/almoxarifado/requisicaoPendentePermissaoRepository'
import requisicaoAberturaFechamento from '@/repositories/conecta-sus/almoxarifado/requisicaoAberturaFechamentoRepository'
import balancete from '@/repositories/conecta-sus/almoxarifado/balanceteRepository'
import transferencia from '@/repositories/conecta-sus/almoxarifado/transferenciaRepository'
import relatorioEstornoEntrada from '@/repositories/conecta-sus/almoxarifado/relatorioEstornoEntradaRepository'
import relatorioEstornoSaida from '@/repositories/conecta-sus/almoxarifado/relatorioEstornoSaidaRepository'
import relatorioValidadeMaterial from '@/repositories/conecta-sus/almoxarifado/relatorioValidadeMaterialRepository'
import relatorioSaida from '@/repositories/conecta-sus/almoxarifado/relatorioSaidaRepository'
import relatorioPosicaoEstoque from './relatorioPosicaoEstoqueRepository'
import relatorioRequisicao from '@/repositories/conecta-sus/almoxarifado/relatorioRequisicaoRepository'
import relatorioConsumoMedioMensal from '@/repositories/conecta-sus/almoxarifado/relatorioConsumoMedioMensalRepository'
import dispensacaoMateriais from './dispensacaoMateriaisRepository'

export default baseUrl => {

    baseUrl = `${baseUrl}/almoxarifado`

    return {
        relatorioConsumoFinanceiro:relatorioConsumoFinanceiro(baseUrl),
        relatorioEntrada:relatorioEntrada(baseUrl),
        motivoBaixa: motivoBaixa(baseUrl),
        entrada: entrada(baseUrl),
        saida: saida(baseUrl),
        baixa: baixa(baseUrl),
        inventario: inventario(baseUrl),
        entradaInicial: entradaInicial(baseUrl),
        parametrizacao: parametrizacao(baseUrl),
        requisicaoPendentePermissao: requisicaoPendentePermissao(baseUrl),
        requisicaoAberturaFechamento: requisicaoAberturaFechamento(baseUrl),
        balancete: balancete(baseUrl),
        transferencia: transferencia(baseUrl),
        relatorioEstornoEntrada: relatorioEstornoEntrada(baseUrl),
        relatorioEstornoSaida: relatorioEstornoSaida(baseUrl),
        relatorioValidadeMaterial: relatorioValidadeMaterial(baseUrl),
        relatorioSaida: relatorioSaida(baseUrl),
        relatorioPosicaoEstoque: relatorioPosicaoEstoque(baseUrl),
        relatorioRequisicao: relatorioRequisicao(baseUrl),
        relatorioConsumoMedioMensal: relatorioConsumoMedioMensal(baseUrl),
        dispensacaoMateriais: dispensacaoMateriais(baseUrl)
    }
}